/**
 * The people shown under "Ta kontakt" on the "Om oss" page, in display order.
 * Names and contact details are the same in every language, so they live here and not in the
 * translations. Leave `phone` or `email` empty until we have it: the card keeps the row and
 * shows a dash. `fox` picks the details of each person's fox portrait (see FoxPortrait).
 */
export const CONTACTS = [
  {
    id: 'nam',
    name: 'Nam Mai',
    phone: '+47 934 79 917',
    email: 'nam@revetall.ai',
    fox: { hair: true, top: 'shirt' },
  },
  {
    id: 'gerhard',
    name: 'Gerhard Wiese',
    phone: '+47 938 70 210',
    email: 'gerhard@revetall.ai',
    fox: { beard: true, top: 'sweater' },
  },
];

/** Where every "Prøv gratis" button leads: the "Ta kontakt" cards on the "Om oss" page. */
export const CONTACT_PATH = '/om-oss#kontakt';
